/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";
import { BookACallButton } from "@/components/BookACallButton";
import { SpecLabel } from "@/components/Section";

export default function NotFoundPage() {
    return (
        <>
            <SEO
                title="Page not found"
                description="That page doesn't exist. But the seven systems do."
                path="/404"
                noindex
            />
            <section
                className="relative overflow-hidden bg-white"
                data-testid="not-found-page"
            >
                <div
                    className="absolute inset-0 blueprint-grid opacity-40 pointer-events-none"
                    aria-hidden="true"
                />
                <div
                    className="absolute inset-0 hero-edge-glow pointer-events-none"
                    aria-hidden="true"
                />
                <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 text-center">
                    <SpecLabel className="justify-center">404 / Not Found</SpecLabel>
                    <h1 className="mt-4 font-display font-extrabold text-5xl sm:text-7xl tracking-tight text-[#0a0b0d]">
                        That page's a ghost.
                    </h1>
                    <p className="mt-5 text-base sm:text-lg text-[#4a5562]">
                        But the seven systems are real. Head back home or
                        book a call.
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                        <BookACallButton
                            size="md"
                            testId="not-found-book-a-call-button"
                        />
                        <Link
                            to="/"
                            data-testid="not-found-home-link"
                            className="inline-flex items-center gap-2 h-12 px-5 text-sm font-display font-bold text-[#0a0b0d] border-2 border-[#0a0b0d]/12 hover:border-[#188bf6] hover:text-[#188bf6] rounded-xl transition-colors"
                        >
                            <ArrowLeft className="w-4 h-4" /> Back home
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
